import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http.service';

@Injectable()
export class UserInfoService {

    constructor(
        private http: HttpService
    ) { }

    modifyInfo(postbody) {
        return this.http.post('api/srm/userAuthority/modifyUser', postbody)
            .switchMap(res => this.http.mapRes(res));
    }


}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/services/user-info.service.ts